import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useEspelhoPeriodoOutletContext } from 'pages/RelatorioEspelhoPeriodo'
import { useParams } from 'react-router-dom'
import { espelhoPeriodo } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirRelatorioEspelhoPeriodo() {
    const { id } = useParams()
    const { data } = useEspelhoPeriodoOutletContext()
    const item = data.find(item => item.id === id)

    const { mutateAsync, isLoading } = espelhoPeriodo.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!item) return null

    const handleSubmit = () =>
        mutateAsync(item.id as any, {
            onSuccess: () => {
                toast.success('Relatório excluído com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            width="sm"
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'EspelhoPontoPorPeríodo'])}
        >
            <Dialog.Content>
                Realmente deseja excluir o relatório de{' '}
                {dayjs.utc(item.createdAt).format('L')}?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
